import { ageHours, ago, fmtDate } from '../lib/format';

/**
 * When a number was fetched (spec §9 "every number shows when it was fetched"). Past
 * `maxAgeHours` (its cadence) the dot turns warn. `variant="pill"` is the top-bar pill;
 * `variant="text"` is a quiet inline line for cards and tables.
 */
export function Freshness({
  at,
  maxAgeHours = 26,
  prefix = 'Checked',
  variant = 'text',
  className,
}: {
  at: string | null | undefined;
  maxAgeHours?: number;
  prefix?: string;
  variant?: 'pill' | 'text';
  className?: string;
}) {
  const none = !at || !Number.isFinite(ageHours(at));
  const stale = none || ageHours(at) > maxAgeHours;
  const text = none ? 'Not checked yet' : `${prefix} ${ago(at)}`;
  const title = none ? 'No data has been fetched yet' : `${prefix} ${fmtDate(at, { time: true })}${stale ? ', older than expected' : ''}`;
  const cls = ['fresh', variant === 'pill' ? 'pill upd' : 'text', className].filter(Boolean).join(' ');
  return (
    <span className={cls} title={title}>
      <span className={`dot${stale ? ' w' : ''}`} aria-hidden="true" />
      <span>{text}</span>
      {stale && !none ? <span className="sr-only"> (older than expected)</span> : null}
    </span>
  );
}
